export default {
    noEvent: 'Kein Ereignis gefunden',
    noEventDesc: 'Bitte melden Sie sich erneut an.',
    noLocation: 'Ort nicht definiert',
    guestList: 'Gästeliste',
    guestListDesc: 'Sehen Sie, wer an der Veranstaltung teilnimmt.',
    tasks: 'Aufgaben',
    tasksDesc: 'Zeitplan und Aufgaben anzeigen.',
    budget: 'Budget',
    budgetDesc: 'Geschätztes Budget anzeigen.',
    welcomeTitle: 'Willkommen in Ihrem Gästebereich',
    welcomeDesc: 'Hier können Sie Veranstaltungsinformationen einsehen und die Gästeliste sehen. Weitere Funktionen folgen bald!'
};
